
import React from 'react';
import styled from 'styled-components';

const PaymentSection = ({
  paymentMethod,
  handlePayment
}) => {

  return (
    <Wrapper>
      <div className="payment-section">
        <fieldset>
          <legend>
            Payment Methods
          </legend>
          <p>
            Choose One
          </p>

          <div className="payment-type">
            <div className="payment-select">
              <input
                id="Advance"
                name="payments"
                onChange={handlePayment}
                value="Advance"
                type="radio"
                checked={paymentMethod === "Advance"}
                className="payment-radio"
              />
              <label htmlFor="Advance">
               Advance
              </label>
            </div>


            <div className="payment-select">
              <input
                id="CAD"
                name="payments"
                onChange={handlePayment}
                value="CAD"
                type="radio"
                checked={paymentMethod === "CAD"}
                className="payment-radio"
              />

              <label htmlFor="CAD">
               Cash Against Documents
              </label>

            </div>

          </div>

        </fieldset>

      </div>

    </Wrapper>
  );
};


const Wrapper = styled.section`

  .payment-section {
    margin: 1rem;
  }

  legend {
    font-size: 1.6rem;
  }

  fieldset {
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    padding: 1rem;
  }

  .payment-type {
   font-size: 1.4rem;
       
    }

 .payment-select {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap:1rem;
  }
    
label {
    display: flex;
    align-items: center;
    align-text: center;
    font-size: 12px;
    font-weight: bold;   
    margin-bottom: 1.5rem;
    }

  .payment-radio {
    width: 1rem;
    height: 1rem;
    accent-color: #4f46e5;
    padding: 1rem 1rem;
}
    


`;

export default PaymentSection;

